import { Button } from './ui/button';
import WhatsAppLogo from '../assets/whatsapp.svg';

function WhatsAppButton({ phone }) {

    const openWhatsapp = () => {
        const phoneWithoutPlus = phone.replace(/\+/g, "");
        const url = `https://wa.me/${phoneWithoutPlus}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };
    
    return (
        <Button
            className="px-6 rounded-md"
            onClick={() => openWhatsapp()}
        >
            <img src={WhatsAppLogo} alt='WhatsApp' className='h-4' />
            Message
        </Button>
    )
}

export default WhatsAppButton;